import React from "react"
import Fader from "react-fader"
import theme from "../../../config/theme";
import Product from "../../elements/Product/Product"
import Card from "../../elements/Card/Card"


const ProductGrid = (props) => {
    if(!props.products) {
        return (<></>);
    }

    return (
        <Fader animateHeight={true} shouldTransition={(oldChildren, newChildren) => {
            let o = oldChildren.props.children[1];
            let n = newChildren.props.children[1];

            if(o.length === 0 && n.length > 0) {
                return true;               
            }

            for(let i in o) {
                if(i > 8) {
                    return false;
                }
                if(o[i] && n[i] && o[i].key !== n[i].key) {
                    return true;
                }
            }

            return false;
        }}>
            <div className={`product-grid-wrapper ${props.enabled ? '' : 'disabled'}`}>
                <style jsx>{`
                    .product-grid-wrapper {
                        margin-top: 10px;
                        display: grid;
                        grid-template-columns: repeat(6, minmax(220px, 1fr));
                        grid-row-gap: 20px;
                        grid-column-gap: 10px;
                        transition: opacity 0.1s;
                    }

                    .product-grid-wrapper.disabled {
                        opacity: 0.9;
                    }
                    
                    @media only screen and (max-width: 1700px) {
                        .product-grid-wrapper { 
                            grid-template-columns: repeat(4, minmax(220px, 1fr));
                        }
                    }

                    @media only screen and (max-width: 1250px) {
                        .product-grid-wrapper { 
                            grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
                        }
                    }

                    @media only screen and (max-width: ${theme.responsive.m}px) {
                        .product-grid-wrapper {
                            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
                            grid-gap: 10px;
                        }
                    }
                `}</style>

                    {props.products.map((product, index) => (
                        props.type === "singles" || props.type === "singles-search" ? 
                            <Card priority={index < 15} product={product} key={`card-${product.id}`}/> :
                            <Product priority={index < 15} product={product} key={`product-${product.id}`}/>
                        
                    ))}
            </div>
        </Fader>
       
    )
}

export default ProductGrid;